const SCROLL_TO_BEHAVIOR = {
  SMOOTH: 'smooth',
  INSTANT: 'instant',
  AUTO: 'auto',
};

Object.freeze(SCROLL_TO_BEHAVIOR);

export default SCROLL_TO_BEHAVIOR;
